import { classnames } from '@aibees/shared/utils';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { SubscriptionDialogProps as Props } from './types';

export const SubscriptionDialog = memo(
  ({ className, open, onClose, title, children }: Props) => {
    return (
      <Styled.Wrapper
        open={open}
        className={classnames('SubscriptionDialog', className)}
        sx={SX.root}
        onClose={onClose}
        maxWidth="md"
      >
        {!!title && <DialogTitle sx={SX.title}>{title}</DialogTitle>}
        <DialogContent sx={SX.content}>{children}</DialogContent>
        {onClose && (
          <DialogActions sx={SX.actions}>
            <Button
              onClick={onClose}
              color="default"
              variant="text"
              size="medium"
            >
              Close
            </Button>
          </DialogActions>
        )}
      </Styled.Wrapper>
    );
  }
);

SubscriptionDialog.displayName = 'SubscriptionDialog';
